export default __webpack_public_path__ + "static/media/litmus.629b95a9.svg";